export default function BlogTip({ title, text }) {
	return (
		<div className="bg-green-50 border border-green-200 rounded-lg p-5 my-8">
			<h4 className="font-semibold text-green-700 mb-2">{title}</h4>
			<p className="text-gray-700">{text}</p>
		</div>
	);
}
